import axios from "axios";

// Tum API cagrilari buradan gecer.
//
// Backend artik /api/login disindaki her ucta JWT istiyor; token'i her istege
// tek tek eklemek yerine burada bir kez ekleniyor. Bu dosya, local (gelistirme)
// ve LocalHost (canli) agaclari arasindaki TEK farkli dosyadir - canlida panel
// ve API ayni origin'den servis edildigi icin baseURL goreli.

const api = axios.create({ baseURL: "/api" });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("adminToken");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Token'in omru 12 saat. Suresi dolunca kullaniciyi sessizce giris ekranina al -
// aksi halde sayfa "yukleniyor" durumunda takili kaliyor.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("adminToken");
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  },
);

export default api;
